import React from 'react';
import { Image } from 'semantic-ui-react';
import $ from 'jquery';
import renderPlan from './plan';
import renderInformations from './informations';

import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import { renderCheckboxList, columnWidth } from 'utils/async-list';

export const list = () => {
  $('tr').on('click', evt => {
    const url = $(evt.currentTarget).attr('data-url');
    window.location.assign(url);
  });
};

export const plan = ctx => {
  handleUpdateImage();

  // Render React app
  renderPlan(ctx.params.id);
};

export const informations = ctx => {
  // Render React app
  renderInformations(ctx.params.id);
};

function handleUpdateImage() {
  const $updateImageButton = $('#bt-update-image');
  const $form = $updateImageButton.closest('form');
  const $imageInput = $form.find('input[name="image"]');

  // Handling buttons
  $updateImageButton.on('click', evt => {
    evt.preventDefault();
    $imageInput.trigger('click');
  });

  $imageInput.on('change', () => $form.submit());
}

export function bySite(ctx) {
  const site = ctx.params.id;
  render(
    `/pco-manager/sites/${site}/zones/range.json`,
    `/pco-manager/sites/${site}/zones`
  );
}

function render(url, from) {
  const zoneTemplateUrl = id =>
    withReferer(`/pco-manager/sites/zones/${id}`, from);

  const rowClickedUrl = id => zoneTemplateUrl(id);
  const loadNextUrl = url;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

function renderColumns(width) {
  return [
    <Column
      key="image"
      dataKey="image"
      cellRenderer={renderImage}
      width={columnWidth(width, 4)}
      label=""
      disableSort
    />,
    <Column
      key="name"
      dataKey="name"
      width={columnWidth(width, 12)}
      label="Nom de la zone"
    />,
  ];
}

function renderImage({ cellData, rowData }) {
  if (rowData.image) {
    return <Image src={rowData.image.original} size="tiny" />;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/index.js